import Vuex from 'vuex'
import addOnSelections from './modules/addOnSelections'

// Because of potential name collisions with other Vuex projects
// We are using a namespaced module (qualifications) as the "root"
// for this project.
const store = new Vuex.Store({
  modules: {
    qualifications: {
      namespaced: true,
      modules: {
        addOnSelections
      },
    },
  },
})

export default store

// This causes jest to ignore this file for coverage as it's not pertinent
/* istanbul ignore file */
